<template>
  <div>
    <!-- 新動線の S3。代理予約の参加者・電話番号・国籍を S1 から移してここで聞き、予約質問は旧動線と同じ一覧（ReservationQuestionFields）を使う（D-042） -->
    <div class="mb-8 flex flex-col gap-[20px] font-Spectral">
      <div>
        <!-- 外しても参加者の欄は消さない。外していれば送信側で落ちる（buildReservationGuestFromStep2） -->
        <div class="flex items-start gap-x-3">
          <input
            id="someone-else-checkbox"
            v-model="form.step2.shouldShowSomeoneElseForm"
            aria-controls="someone-else-fields"
            class="mt-1 h-4 w-4 cursor-pointer accent-gold1"
            type="checkbox"
          />
          <label class="cursor-pointer text-sm leading-relaxed" for="someone-else-checkbox">I'm booking for someone else</label>
        </div>
        <!-- チェックしている間は、下の電話番号・国籍も参加者の欄に切り替わる（GuestContactFields） -->
        <div v-show="form.step2.shouldShowSomeoneElseForm" id="someone-else-fields" class="mt-4 flex flex-col gap-y-4">
          <p class="text-sm text-light-fg-muted">Please enter the lead participant's details.</p>
          <div class="flex justify-between gap-[2%]">
            <FloatingLabelTextInput
              aria-label="participantFirstName"
              autocomplete="section-participant given-name"
              label="First name"
              :error="errorMessages.participantFirstName"
              :model-value="form.step2.participantFirstName"
              :on-update-model-value="updateField.participantFirstName"
            />
            <FloatingLabelTextInput
              aria-label="participantLastName"
              autocomplete="section-participant family-name"
              label="Last name"
              :error="errorMessages.participantLastName"
              :model-value="form.step2.participantLastName"
              :on-update-model-value="updateField.participantLastName"
            />
          </div>
          <FloatingLabelTextInput
            aria-label="forSomeoneElseEmail"
            autocomplete="section-participant email"
            label="Email"
            type="email"
            :error="errorMessages.forSomeoneElseEmail"
            :model-value="form.step2.forSomeoneElseEmail"
            :on-update-model-value="updateField.forSomeoneElseEmail"
          />
        </div>
      </div>
      <h4 v-if="!form.step2.shouldShowSomeoneElseForm" class="text-base tracking-normal text-black2">Your details</h4>
      <GuestContactFields :get-error-message="getErrorMessage" />
    </div>
    <ReservationQuestionFields v-if="hasReservationQuestions" :get-error-message="getErrorMessage" />
  </div>
</template>

<script setup lang="ts">
import FloatingLabelTextInput from '@/wabunka-src/common/components/stateful/FloatingLabelTextInput/FloatingLabelTextInput.vue';
import { useGlobalWabunkaReservationForm } from '@/wabunka-src/common/features/Reservation/composables/forms/useGlobalWabunkaReservationForm';
import GuestContactFields from '@/wabunka-src/features/Experience/subFeatures/Reservation/pages/Reserve/components/ReservationSection/ReservationStep2Form/GuestContactFields/GuestContactFields.vue';
import ReservationQuestionFields from '@/wabunka-src/features/Experience/subFeatures/Reservation/pages/Reserve/components/ReservationSection/ReservationStep2Form/ReservationQuestionFields/ReservationQuestionFields.vue';

interface Props {
  getErrorMessage: (s: string) => string;
}

const props = defineProps<Props>();

const { form } = useGlobalWabunkaReservationForm();

const hasReservationQuestions = computed(() => form.value.step2.reservationQuestionAnswers.length > 0);

const errorMessages = computed(() => ({
  participantFirstName: props.getErrorMessage('step2.participantFirstName'),
  participantLastName: props.getErrorMessage('step2.participantLastName'),
  forSomeoneElseEmail: props.getErrorMessage('step2.forSomeoneElseEmail'),
}));

const updateField = {
  participantFirstName: (value: string) => (form.value.step2.participantFirstName = value),
  participantLastName: (value: string) => (form.value.step2.participantLastName = value),
  forSomeoneElseEmail: (value: string) => (form.value.step2.forSomeoneElseEmail = value),
};
</script>
